module.exports = __webpack_public_path__ + "img/dogs-1.9e9781b9.jpg";